import React, { useEffect } from 'react'

const Service = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  },[]);

  return (
    <div>
  {/* Service Start */}
<div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{maxWidth: 600}}>
      <h5 className="fw-bold text-primary text-uppercase">Our Service &amp; Courses</h5>
      <h1 className="mb-0">Custom IT Training for Your Successful Career</h1>
    </div>
    <div className="row g-5">
      <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
        <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
          <div className="service-icon">
            <i className="fa fa-chart-pie text-white" />
          </div>
          <h4 className="mb-3">DB Admin</h4>
          <p className="m-0">A database administrator (DBA) is the information technician responsible for directing or performing all activities related to maintaining a successful database environment</p>
          <a className="btn btn-lg btn-primary rounded" href>
            <i className="bi bi-arrow-right" />
          </a>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.9s">
        <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
          <div className="service-icon">
            <i className="fa fa-code text-white" />
          </div>
          <h4 className="mb-3">Web Developer</h4>
          <p className="m-0">A web developer’s job is to create websites. While their primary role is to ensure the website is visually appealing and easy to navigate, many web developers are also responsible for the website’s performance and capacity. </p>
          <a className="btn btn-lg btn-primary rounded" href>
            <i className="bi bi-arrow-right" />
          </a>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
        <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
          <div className="service-icon">
            <i className="fab fa-android text-white" />
          </div>
          <h4 className="mb-3">Apps Development</h4>
          <p className="m-0">n application developer's typical responsibilities include coding, designing, application management, troubleshooting, monitoring updates and possible security threats, and providing end user support.</p>
          <a className="btn btn-lg btn-primary rounded" href>
            <i className="bi bi-arrow-right" />
          </a>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
        <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
          <div className="service-icon">
            <i className="fa fa-search text-white" />
          </div>
          <h4 className="mb-3">SEO Analyst</h4>
          <p className="m-0">SEO analysts help an organisation to increase the number of people viewing its website(s) by analysing data on website performance and staying on top of ever-changing SEO trends.</p>
          <a className="btn btn-lg btn-primary rounded" href>
            <i className="bi bi-arrow-right" />
          </a>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
        <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
          <div className="service-icon">
            <i className="fa fa-shield-alt text-white" />
          </div>
          <h4 className="mb-3">System &amp; Network Admin</h4>
          <p className="m-0">System and network administrators manage an organization's technical infrastructure. Job activities include everything from designing and implementing network schemas to managing digital licenses and hardware assets.</p>
          <a className="btn btn-lg btn-primary rounded" href>
            <i className="bi bi-arrow-right" />
          </a>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
        <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
          <div className="service-icon">
            <i className="fa fa-shield-alt text-white" />
          </div>
          <h4 className="mb-3">Software Testing</h4>
          <p className="m-0">Software testing is the process of evaluating and verifying that a software product or application does what it is supposed to do. The benefits of testing include preventing bugs, reducing development costs and improving performance.</p>
          <a className="btn btn-lg btn-primary rounded" href>
            <i className="bi bi-arrow-right" />
          </a>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
        <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
          <div className="service-icon">
            <i className="fa fa-shield-alt text-white" />
          </div>
          <h4 className="mb-3">Artificial Intelligence &amp; Machine Learning</h4>
          <p className="m-0">Artificial intelligence is a technology that enables a machine to simulate human behavior. Machine learning is a subset of AI which allows a machine to automatically learn from past data without programming explicitly. </p>
          <a className="btn btn-lg btn-primary rounded" href>
            <i className="bi bi-arrow-right" />
          </a>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
        <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
          <div className="service-icon">
            <i className="fa fa-shield-alt text-white" />
          </div>
          <h4 className="mb-3">Graphics Designer</h4>
          <p className="m-0">Graphic Designers create visual concepts to communicate information. They create everything from posters and billboards to packaging, logos and marketing materials. </p>
          <a className="btn btn-lg btn-primary rounded" href>
            <i className="bi bi-arrow-right" />
          </a>
        </div>
      </div>
      <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.9s">
        <div className="position-relative bg-primary rounded h-100 d-flex flex-column align-items-center justify-content-center text-center p-5">
          <h3 className="text-white mb-3">Call Us For Details</h3>
          <p className="text-white mb-3">You can ask for best customized courses and time availablity details with our customer care</p>
          <h2 className="text-white mb-0">+91 86672 02180</h2>
        </div>
      </div>
    </div>
  </div>
</div>
{/* Service End */}

    </div>
  )
}

export default Service